<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div *ngIf="this.label != null" class="col-md-12">
      <div  class="form-label" >
        {{this.label}}
        <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
        <span *ngIf="this.tooltip != null" class="mt-1">
          <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
        </span> 
      </div> 
    </div>
    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>

  <div class="row mt-10" *ngFor="let d of this.listData; let i=index;">
    <div class="col-12 ">
      <label class="container-radio"  for={{i}}>{{d.display}}
          <input id={{i}} 
          type="radio" 
          formControlName="{{this.propertyName}}"  
          value="{{d.code}}" 
          (click)="this.userAction(d.code, $event.target.checked)"
          checked="" >
          <span class="checkmark"></span>
      </label> 
    </div>
  </div>  

</div>